// extracted by mini-css-extract-plugin
module.exports = {"product-footer":"ProductFooter_product-footer__1fgWO"};